import React, { useCallback, useEffect, useState } from 'react'
import AdminHeader from './AdminHeader.js'
import { Link, useLocation } from 'react-router-dom';
import { useMutation, useQuery } from '@apollo/client';
import { GET_SUPPORT, UPDATE_SUPPORT } from '../graphql/Query/GetSupport.js';
import moment from 'moment';
import { FaCheckCircle } from "react-icons/fa";
import Select from "react-select";
// import Pagination from '../components/Pagination.js';
import NoDataFound from '../components/NoDataFound.js';
import CustomPagination from '../components/Pagination.js';
import useScrollToTop from '../components/useScrollToTop.js';
import Table from "../components/Table/index.jsx";
import { issueCategories } from './AllCustomerDetails/AdminCustomerEscalation.js';
import { getDateRange } from '../Common/GetDateRange.js';
import DateFilter from '../Common/DateRange.js';
import { typeOptionsData } from './AllCustomerDetails/AdminSingleEscalation.js';
import { ticketTypeIsueOptionsData } from '../Common/Constant.js';


const AdminTicket = () => {
    useScrollToTop();
    const [selectedStatus, setSelectedStatus] = useState();
    const [selectedType, setSelectedType] = useState();
    const location = useLocation();
    const todayTicket = location?.state?.dailyCountSupport
    const [isOn, setIsOn] = useState({});
    const [searchUser, setSearchUser] = useState('');
    const [toDate, setToDate] = useState('');
    const [fromDate, setFromDate] = useState('');
    const [filter, setFilter] = useState('');
    const [activeButton, setActiveButton] = useState('open');
    // const [ setActiveData] = useState([]);
    // const [ setActiveFalse] = useState([]);
    const [active, setActive] = useState();
    const [finalRange, setFinalRange] = useState({
        filterType: "Last 30 Days",
        startDate: new Date(),
        endDate: new Date(),
    });
    const [todayTicketCount, setTodayTicketCount] = useState(0);

    const [updateSupport] = useMutation(UPDATE_SUPPORT);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const { data, refetch, loading } = useQuery(GET_SUPPORT, {
        variables: {
            page: page,
            limit,
            sort: {
                key: "updatedAt",
                type: -1
            },
            filter: filter,
            from: finalRange?.startDate?.toISOString(), // Use updated startDate
            to: finalRange?.endDate?.toISOString(),
            status: active,
            ticketstatus: selectedStatus,
            tickettype: selectedType,
        },
        fetchPolicy: 'cache-and-network'
    });
    const handleDateChange = useCallback((range) => {
        setFinalRange(range);
    }, []);
    useEffect(() => {
        if (data?.getSupport?.data) {
            const supportData = data.getSupport.data;
            const active = supportData.filter((item) => item.isActive === true);
            const inactive = supportData.filter((item) => item.isActive === false);
            const today = moment().startOf('day');
            const todayTickets = supportData.filter((ticket) => moment(ticket.createdAt).isSame(today, 'day'));

            // setActiveData(active);
            // setActiveFalse(inactive);
            setTodayTicketCount(todayTickets.length);
            filterData();
        }
    }, [data, activeButton]);

    const filterData = () => {
        if (data?.getSupport?.data) {
            if (activeButton === 'open') {
                setActive(true);
            } else if (activeButton === 'close') {
                setActive(false);
            }
        }
    };

    const toggleSwitch = async (id) => {
        try {
            const newIsOn = !isOn[id];
            const { data } = await updateSupport({ variables: { updateSupportId: id, isActive: newIsOn } });
            if (data.updateSupport) {
                refetch();
                setIsOn(prev => ({ ...prev, [id]: newIsOn }));
            } else {
                console.error('Failed to update support status');
            }
        } catch (error) {
            console.error('Error updating support status:', error);
        }
    };

    const fromDateChange = (e) => {
        setFromDate(e.target.value);
    }

    const toDateChange = (e) => {
        setToDate(e.target.value)
    }

    const searchCustomerUser = () => {
        setFilter(searchUser)
    }

    const handleSearch = (e) => {
        searchCustomerUser()
    }

    const handleReset = () => {
        setFromDate('');
        setToDate('');
        setFilter('');
        setSelectedStatus();
        setSelectedType();
        setSearchUser('');
        const defaultRange = getDateRange("Last 30 Days");
        setFinalRange({
            filterType: "Last 30 Days",
            startDate: defaultRange?.startDate,
            endDate: defaultRange?.endDate,
        });

        handleDateChange({
            filterType: "Last 30 Days",
            startDate: defaultRange?.startDate,
            endDate: defaultRange?.endDate,
        });

    }

    const handlePageClick = (selectedPage) => {
        setPage(selectedPage);
    };

    const columns = [
        { name: "No.", selector: (row, index) => index + 1 + ((page - 1) * limit), sortable: true },
        {
            name: "Ticket ID",
            selector: (row) => row?.ticketID,
            sortable: true,
            cell: (row) => <span className="font-medium text-blue-600 py-10 text-xs">{row?.ticketID}</span>,
        },
        {
            name: "Date",
            selector: (row) => moment(row.createdAt).format("DD/MM/YYYY hh:mm A"),
            sortable: true,
        },
        {
            name: "AWB No.",
            cell: (row) => (
                <Link
                    to="/admintrack"
                    state={{ id: row?.order?.id }}
                    className="text-blue-500 underline hover:text-blue-700"
                >
                    {row?.awbNo}
                </Link>
            ),
            sortable: true,
        },
        { name: "Customer Name", selector: (row) => row?.name, sortable: true },
        { name: "Mobile No", selector: (row) => row?.mobile, sortable: true },
        {
            name: "Customer Message",
            cell: (row) => (
                <div className="truncate max-w-xs cursor-pointer" title={row.message.map(m => `${m?.sender}: ${m?.message} (${new Date(m?.createdAt).toLocaleString()})`).join(", ")}>
                    {row?.message?.map(m => `${m?.sender}: ${m.message} (${new Date(m?.createdAt).toLocaleString()})`).join(", ")}
                </div>
            ),
            sortable: true,
        },
        {
            name: "ESCALATION TYPE",
            selector: (row) => row?.issue_type,
            cell: (row) => (
                <div className='flex-col'>
                    <div className="flex items-center mb-3 gap-2 font-medium text-xs">
                        {row?.issue_type ? row?.issue_type : "Shipment Issue"}

                    </div>
                    <p className="inline text-xs border mt-3 border-sky-300 bg-sky-50 rounded-md px-2 py-1">
                        {row?.ticket_type_issue ? row?.ticket_type_issue : "Shipment"}
                    </p>
                </div>
            ),
        },
        {
            name: "DETAILS",
            selector: (row) => row?.issue_category,
            cell: (row) => (
                <div className="flex flex-col gap-1 font-medium text-xs">
                    {/* Display issue category if it's not in issueCategories */}
                    {!issueCategories?.includes(row?.issue_category) && (
                        <span>{row?.issue_category}</span>
                    )}

                    {/* Display AWB Number if available */}
                    {(row?.awbNo || row?.order?.awb_number) && (
                        <p className="text-blue-600">
                            AWB:{" "}
                            <Link
                                to="/admintrack"
                                state={{ id: row?.order?.id }}
                                className="underline hover:text-blue-800"
                            >
                                {row?.awbNo || row?.order?.awb_number}
                            </Link>
                        </p>
                    )}




                    {/* Static Status */}
                    {(row?.order?.status || row?.status) && <p className="font-semibold text-xs">Status: <span className='font-bold'>{row?.order?.status || row?.status}</span></p>}
                </div>
            )
        },
        {
            name: "STATUS",
            selector: (row) => row?.order?.status,
            cell: (row) => {
                const statusColor = {
                    "New": "text-gray-500",
                    "Assigned": "text-indigo-600",
                    "Escalated to operation": "text-blue-500",
                    "Pending from seller": "text-yellow-600",
                    "Cancelled": "text-red-600",
                    "Closed": "text-green-600",
                    "Follow Up": "text-purple-600",
                    "Re-Opened": "text-yellow-600"
                };

                const status = row?.status?.trim(); // Trim to avoid leading/trailing space issues

                return (
                    <span
                        className={`px-3 py-1 text-xs font-semibold ${statusColor[status] || "text-black"}`}
                    >
                        <FaCheckCircle className="inline-block mr-1" />
                        {status}
                    </span>
                );
            }
        },
        // {
        //     name: "Full Details",
        //     cell: (row) => (
        //         <Link to="/admintrack" state={{ id: row?.order?.id }} className="text-blue-400 font-semibold">
        //             View Details
        //         </Link>
        //     ),
        // },
        {
            name: "ACTION",
            cell: (row) => (
                <Link
                    to='/singleEscalationAdmin'
                    state={{ row }}
                    className="border border-gray-300 px-4 py-2 text-black text-xs font-medium rounded-md flex flex-col items-center justify-center hover:bg-gray-100 transition"
                >
                    View <br /> Escalation
                </Link>
            ),
            width: "150px",
        },
        {
            name: "Ticket Status",
            cell: (row) => (
                <button
                    onClick={() => toggleSwitch(row.id)}
                    className="px-4 py-1 border border-gray-900 text-gray-900 rounded-md hover:bg-slate-900 hover:text-white bg-white transition-colors duration-300"
                >
                    Close
                </button>
            ),
        },
    ];
    const handlePagination = (page) => {
        // console.log('✌️page --->', page);
        // setLoader(true);
        setPage(page?.selected);
    };

    return (
        <div>
            <div>
                {/* <AdminHeader /> */}
                <div className="mx-auto max-w-auto px-2 sm:px-6 lg:px-0 my-10 ">
                    <div className='md:flex space-y-7 md:space-y-0 justify-between'>
                        <div className='flex space-x-6'>
                            <h2 className="text-lg font-bold text-gray-900">All Ticket</h2>
                            <div className="lg:col-span-3 space-y-3">
                                <div className="flex space-x-5">
                                    <button
                                        className={` ${activeButton === 'open' ? 'bg-green-600 text-white px-3 py-1 rounded-lg font-semibold' : 'font-semibold text-gray-400 '}`}
                                        onClick={() => { setActiveButton('open'); setPage(0) }}
                                    >
                                        Open
                                    </button>
                                    <button
                                        className={` ${activeButton === 'close' ? 'bg-red-600 text-white px-3 py-1 rounded-lg font-semibold' : 'font-semibold text-gray-400 '}`}
                                        onClick={() => { setActiveButton('close'); setPage(0) }}
                                    >
                                        Closed
                                    </button>
                                </div>
                            </div>
                        </div>
                        <h2 className="text-lg font-semibold">Today Ticket - {todayTicket}</h2>
                    </div>
                    <div className='p-4 max-w-full mx-auto bg-slate-50 ring-1 ring-gray-200 rounded-xl space-y-4'>
                        <div className='flex justify-between'>
                            <h2 className="text-lg font-semibold">Pickup Filters</h2>
                            <button className="px-4 py-1 border border-slate-900 text-slate-900 rounded-md hover:bg-slate-900 hover:text-white bg-white transition-colors duration-300" onClick={handleReset}>
                                Reset
                            </button>
                        </div>

                        <div className='lg:flex space-y-7 lg:space-y-0 lg:justify-between'>
                            <div className=''>
                                <p className="text-sm font-medium text-gray-700">Search</p>
                                <div className='md:flex md:space-x-4 space-x-0'>
                                    <div>
                                        <input type="text" onChange={(e) => setSearchUser(e.target.value)} onKeyDown={handleSearch} value={searchUser} placeholder="Search..." className="mt-1 focus:ring-0 focus:ring-inset focus:outline-none focus:ring-slate-600 focus:border-slate-600 mb-2 md:mb-0 w-full md:w-none p-1.5 border rounded-md" />
                                    </div>
                                </div>
                            </div>

                            <div className='md:flex md:space-x-4 space-x-0 space-y-3 md:space-y-0'>
                                <div className="space-y-2">
                                    <label className="block text-sm font-medium text-gray-700">Status:</label>
                                    <Select
                                        options={typeOptionsData}
                                        defaultValue={typeOptionsData[0]}
                                        className="w-full"
                                        value={typeOptionsData.find(option => option?.value === selectedStatus) || null}
                                        onChange={(selectedOption) => setSelectedStatus(selectedOption?.value)}
                                        classNamePrefix="react-select"
                                        styles={{
                                            control: (base, state) => ({
                                                ...base,
                                                borderColor: state.isFocused ? '#d1d5db' : '#d1d5db',
                                                '&:hover': { borderColor: '#64748B' },
                                                boxShadow: state.isFocused ? '0 0 0 0px #000000' : 'none',
                                                borderRadius: '0.375rem',
                                            }),
                                            singleValue: (base) => ({
                                                ...base,
                                                color: '#000000',
                                                fontSize: '0.875rem',
                                            }),
                                            option: (base, state) => ({
                                                ...base,
                                                backgroundColor: state.isSelected ? '#cbd5e1' : state.isFocused ? '#cbd5e1' : 'white',
                                                color: state.isSelected ? '#000000' : '#000000',
                                                fontSize: '0.875rem',
                                                '&:hover': {
                                                    backgroundColor: '#cbd5e1',
                                                    color: '#000000',
                                                    fontSize: '0.875rem',
                                                }
                                            }),
                                            placeholder: (base) => ({
                                                ...base,
                                                fontSize: '14px',
                                                color: '#A3AAB5',
                                                fontSize: '0.875rem',
                                            }),
                                        }}
                                    />
                                </div>
                                <div className="space-y-2">
                                    <label className="block text-sm font-medium text-gray-700">Type:</label>
                                    <Select
                                        options={ticketTypeIsueOptionsData}
                                        isSearchable
                                        defaultValue={null}
                                        className="w-full"
                                        value={ticketTypeIsueOptionsData
                                            .flatMap(group => group.options)
                                            .find(option => option.value === selectedType) || null}
                                        onChange={(selectedOption) => setSelectedType(selectedOption?.value)}
                                        classNamePrefix="react-select"
                                        styles={{
                                            menu: (provided) => ({
                                                ...provided,
                                                maxHeight: 300, // Enables scrolling
                                            }),
                                            control: (base, state) => ({
                                                ...base,
                                                borderColor: state.isFocused ? '#d1d5db' : '#d1d5db',
                                                '&:hover': { borderColor: '#64748B' },
                                                boxShadow: state.isFocused ? '0 0 0 0px #000000' : 'none',
                                                borderRadius: '0.375rem',
                                            }),
                                            singleValue: (base) => ({
                                                ...base,
                                                color: '#000000',
                                                fontSize: '0.875rem',
                                            }),
                                            option: (base, state) => ({
                                                ...base,
                                                backgroundColor: state.isSelected ? '#cbd5e1' : state.isFocused ? '#cbd5e1' : 'white',
                                                color: '#000000',
                                                fontSize: '0.875rem',
                                            }),
                                            placeholder: (base) => ({
                                                ...base,
                                                fontSize: '0.875rem',
                                                color: '#A3AAB5',
                                            }),
                                        }}
                                    />
                                </div>
                                <div className="space-y-2">
                                    <label className="block text-sm font-medium text-gray-700">From Date:</label>
                                    <DateFilter
                                        onDateChange={handleDateChange}
                                        defaultFilterType={finalRange?.filterType}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className="mt-4 " >
                <div className="mx-auto max-w-auto px-2 sm:px-6 lg:px-0 my-10 space-y-6 ">
                    <div className='flex justify-between'>
                        <h2 className="text-lg font-semibold">Open Ticket</h2>


                    </div>
                    <div className="text-gray-600 grid grid-cols-1 ">
                        <p className="font-semibold mb-3">Total: {data?.getSupport?.count}</p>
                        {data?.getSupport?.data?.length > 0 ? (
                            <Table
                                columns={columns}
                                data={data?.getSupport?.data || []}
                                currentPage={page}
                                totalRecords={data?.getSupport?.count || 0}
                                limit={limit}
                                setLimit={setLimit}
                                setPage={setPage}
                                loading={loading}
                                handlePagination={handlePagination}
                            />
                        ) : (
                            <NoDataFound />
                        )}
                    </div>

                </div>
            </div>
        </div>
    )
}

export default AdminTicket
